module.exports = __webpack_public_path__ + "static/media/derek_chu.79309efa.png";